'use client';

import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import './index.scss';

export default function Content({ id, data = {}, initIndex = 0 }: ContentServerProps) {
    const { list = [] } = data;
    const prefixCls = 'series-kv-swiper';

    return (
        <GloLayout className={`editor-series-kv-swiper`} id={id} data={data} floorName={prefixCls}>
            <Swiper
                initialSlide={initIndex}
                pagination={Boolean(list?.length > 1)}
                navigation={Boolean(list?.length > 1)}
                autoplay={{
                    delay: 3000, // 轮播间隔时间（毫秒），默认3000
                    disableOnInteraction: false, // 用户操作后是否停止自动轮播，false表示不停止
                }}
                modules={[Navigation, Pagination, Autoplay]}
                loop={true}
            >
                {list.map((itemA: any, index: number) => {
                    const { title, desc, titleColor, descColor, pc, h5 } = itemA;
                    const itemClassesA = classNames({
                        [`${prefixCls}-item`]: true,
                        [`${prefixCls}-item-${index}`]: true,
                    });
                    return (
                        <SwiperSlide className={itemClassesA} key={`${index}`}>
                            <div className="series-kv-swiper-item-img">
                                <picture className="series-kv-swiper-item-img-picture">
                                    <source media={`(max-width: 1024px)`} srcSet={h5 || pc} />
                                    <img fetchPriority="high" loading="eager" src={pc} alt={title} width="100%" height="100%" />
                                </picture>
                            </div>
                            <div className="series-kv-swiper-item-content">
                                {title && (
                                    <div className="series-kv-swiper-item-content-title" style={{ color: titleColor }} title={title}>
                                        {title}
                                    </div>
                                )}
                                {desc && (
                                    <div className="series-kv-swiper-item-content-desc" style={{ color: descColor }} title={desc}>
                                        {desc}
                                    </div>
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </GloLayout>
    );
}
